import { DashboardProps, DashboardPropsDefaults } from "../types/dashboardProps.d";

const DashboardWidgetTemplate = ({ user }: DashboardProps): JSX.Element => {
    return (
        <div className={DashboardPropsDefaults.containerClassNames}>
            <div className="dashboard-widget-title pb-1">
                <h3>Widget</h3>
            </div>
            <div className={DashboardPropsDefaults.contentClassNames}>

            </div>
        </div>
    );
};

export default DashboardWidgetTemplate;
